// extracted by mini-css-extract-plugin
export default {"dashboardTable":"remittance_dashboardTable__1bEbn","note_text":"remittance_note_text__MiBj2"};